// extracted by mini-css-extract-plugin
export default {"likeButton":"vT-z","unLikedButton":"wT-z","likedButton":"xT-z"};